import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function SelectByType(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path d="M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V4Z"/>
      <path d="M3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14Z"/>
      <path d="M13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4Z"/>
      <path d="M16 13.5C16 13.2239 16.2239 13 16.5 13H17.5C17.7761 13 18 13.2239 18 13.5V20.5C18 20.7761 17.7761 21 17.5 21H16.5C16.2239 21 16 20.7761 16 20.5V13.5Z"/>
      <path d="M13 16.5C13 16.2239 13.2239 16 13.5 16H20.5C20.7761 16 21 16.2239 21 16.5V17.5C21 17.7761 20.7761 18 20.5 18H13.5C13.2239 18 13 17.7761 13 17.5V16.5Z"/>
    </CommonSVGIcon>
  );
}
